import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '../context/AuthContext'; 

interface ProtectedRouteProps {
  redirectPath?: string;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({
  redirectPath = '/properties/home'
}) => {
  const { tokenKey } = useAuth();

  if (!tokenKey) {
    return <Navigate to={redirectPath} replace />;
  }
  return <Outlet />;
};


export default ProtectedRoute;
